module.exports = __webpack_public_path__ + "img/card-bg6.628cb7b7.png";